// removed by extract-text-webpack-plugin
module.exports = {"setting_top_middle":"_32eg5hQU5JwF7xPbqsf1Tp","setting_bottom_right":"_20zPo851-cWZfIUMJoKWel","setting_bottom":"_3Usuo3BxIRvrkTPKK0GY7g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripAdvisor/SettingsComponent.css
// module id = 452
// module chunks = 0